import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, find, propEq } from 'ramda';
import { Box } from '@material-ui/core';

import Loader from 'sharedComponents/Loader';
import useOfferings from 'reducers/hooks/useOfferings';
import useBid from 'reducers/hooks/useBid';
import useFirebaseChat from 'reducers/hooks/firebase/useChat';
import FirebaseChatPresenter from 'presenters/FirebaseChatPresenter';
import { getOfferingsOptions } from 'presenters/OfferingPresenter';
import BidPage from './components/BidPage';

import useStyles from './useStyles';

const LoanOptions = props => {
  const { bidRequestId, chatUid } = props;
  const classes = useStyles();
  const { offerings, loading: offeringsLoading, loadOfferings } = useOfferings();
  const { chats } = useFirebaseChat();
  const { loadBidRequest, loading: bidRequestLoading, bidRequest, createBid, bidsFormValues } = useBid();

  const currentChat = find(propEq('uid', chatUid), chats);
  const bid = FirebaseChatPresenter.latestBid(currentChat);

  useEffect(() => {
    if (isEmpty(offerings)) {
      loadOfferings();
    }
  }, []);

  useEffect(() => {
    loadBidRequest(bidRequestId);
  }, [bidRequestId]);

  const isFetching = isEmpty(bidRequest) || bidRequestLoading;

  const handleReloadBidRequest = () => {
    loadBidRequest(bidRequestId);
  };

  if (isFetching) {
    return (
      <Box className={classes.loaderContainer}>
        <Loader />
      </Box>
    );
  }

  const offeringOptions = getOfferingsOptions(offerings);

  return (
    <Box className={classes.container}>
      <BidPage
        offeringOptions={offeringOptions}
        bidRequest={bidRequest}
        bid={bid}
        bids={bidsFormValues}
        offeringsLoading={offeringsLoading}
        onCreateBid={createBid}
        onReloadBidRequest={handleReloadBidRequest}
      />
    </Box>
  );
};

LoanOptions.propTypes = {
  chatUid: PropTypes.string.isRequired,
  bidRequestId: PropTypes.number.isRequired,
};

export default LoanOptions;



// WEBPACK FOOTER //
// ./src/sharedComponents/LoanOptions/LoanOptions.js